import api from '../api/axios';

export interface Employee {
  id?: number;
  employeeNumber: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  dateOfBirth?: string;
  gender?: 'male' | 'female' | 'other';
  address?: string;
  department?: number;
  position?: string;
  hireDate: string;
  terminationDate?: string;
  employmentType?: 'fullTime' | 'partTime' | 'contract' | 'intern';
  status?: 'active' | 'onLeave' | 'suspended' | 'terminated';
  salary?: number;
  currency?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  employeeIdType?: string;
  employeeId?: string;
  referenceNumber?: string;
  employeeBicCode?: string;
  employeeAccount?: string;
  salaryFrequency?: 'M' | 'W' | 'B' | 'D';
}

const EmployeeService = {
  getAll: (params?: any) => api.get('/employees', { params }),
  getOne: (id: number, params?: any) => api.get(`/employees/${id}`, { params: params || { populate: '*' } }),
  create: (data: Employee) => api.post('/employees', { data }),
  update: (id: number, data: Partial<Employee>) => api.put(`/employees/${id}`, { data }),
  delete: (id: number) => api.delete(`/employees/${id}`),
};

export default EmployeeService;

